import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 14"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M14.367 6.644c.925.056 1.687.404 2.286 1.045.626.612.939 1.448.939 2.507 0 1.253-.381 2.214-1.143 2.883-.762.64-1.66.947-2.694.92-.707 0-1.32-.14-1.837-.419a3.871 3.871 0 0 1-1.224-1.086 5.202 5.202 0 0 1-.735-1.63 8.846 8.846 0 0 1-.204-1.922c0-1.03.177-2.02.53-2.967.382-.947.871-1.81 1.47-2.59a11.473 11.473 0 0 1 2.122-2.048A9.639 9.639 0 0 1 16.328 0c.272.446.544.878.816 1.295.3.418.585.85.857 1.296-.354.223-.721.487-1.102.794a8.826 8.826 0 0 0-1.102.96c-.327.363-.626.739-.898 1.129a4.46 4.46 0 0 0-.53 1.17m-9.755 0c.925.056 1.687.404 2.286 1.045.626.612.939 1.448.939 2.507 0 1.253-.381 2.214-1.143 2.883-.762.64-1.674.947-2.735.92-.68 0-1.279-.14-1.796-.419A3.872 3.872 0 0 1 .94 12.494a5.204 5.204 0 0 1-.735-1.63A8.846 8.846 0 0 1 0 8.942c0-1.03.177-2.02.53-2.967.382-.947.871-1.81 1.47-2.59a11.475 11.475 0 0 1 2.122-2.048A9.637 9.637 0 0 1 6.572 0c.272.446.544.878.816 1.295.3.418.585.85.857 1.296a11.84 11.84 0 0 0-1.102.794 8.824 8.824 0 0 0-1.102.96c-.327.363-.626.739-.898 1.129-.245.39-.422.78-.53 1.17"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }